import { render, staticRenderFns } from "./supplierTable.vue?vue&type=template&id=81613762&scoped=true"
import script from "./supplierTable.vue?vue&type=script&lang=js"
export * from "./supplierTable.vue?vue&type=script&lang=js"
import style0 from "./supplierTable.vue?vue&type=style&index=0&id=81613762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81613762",
  null
  
)

export default component.exports